import React, { useEffect, useMemo } from 'react';

// ReactRouter
import {
  Switch,
  Redirect,
  Route,
  useHistory,
} from 'react-router-dom';

// Routes
import { routes } from 'utils/routes';

// Components
import Header from 'components/Header';
import Footer from 'components/Footer';

// hooks
import useAuth from '../../hooks/useAuth';

// Styles
import 'react-toastify/dist/ReactToastify.css';
import {
  AppLoggedContainer,
  Wrapper,
  StyledToastContainer,
} from './style';

const AppLogged = React.memo(() => {
  const { isAuthenticated, loading, isUserType } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!isAuthenticated && !loading) {
      history.push('/login');
    }
  }, [isAuthenticated, loading]);

  const userRoutes = useMemo(() => {
    if (isAuthenticated && isUserType('admin')) {
      return routes.private.admin;
    }
    return routes.private.user;
  }, [isAuthenticated]);

  if (isAuthenticated) {
    return (
      <AppLoggedContainer>
        <Header />
        <Wrapper>
          <div className="col">
            <Switch>
              {
                userRoutes.map(routeItem => (
                  <Route
                    key={routeItem.route}
                    path={routeItem.route}
                    exact
                    component={routeItem.container}
                  />
                ))
              }
              <Redirect to={userRoutes[0].route} />
            </Switch>
          </div>
        </Wrapper>
        <StyledToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <Footer />
      </AppLoggedContainer>
    );
  }
  return null;
});

export default AppLogged;
